// src/pages/Employees/AccessTab.jsx
import React from 'react';
import { Card, Typography, Space, Tag, Alert } from 'antd';
import {
  GoogleOutlined, SafetyOutlined, SettingOutlined,
  CrownOutlined, InfoCircleOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

export default function AccessTab({ employee }) {
  if (!employee?.email) {
    return (
      <Alert
        type="warning"
        showIcon
        message="У сотрудника не указан email"
        description="Для настройки доступа через Google необходимо добавить корпоративный email."
      />
    );
  }

  const canLogin = employee.can_login ?? false;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Alert
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
        message="Управление доступом — в разделе «Админка → Доступы»"
        description="Здесь показан только текущий статус. Выдать или отозвать доступ и роли можно централизованно в админке."
      />

      <Card size="small" style={{
        background: canLogin ? '#f6ffed' : '#fff2f0',
        borderColor: canLogin ? '#b7eb8f' : '#ffccc7',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <GoogleOutlined style={{ fontSize: 24, color: canLogin ? '#52c41a' : '#bbb' }} />
          <div style={{ flex: 1 }}>
            <Text strong>Вход через Google</Text>
            <div><Text type="secondary" style={{ fontSize: 12 }}>{employee.email}</Text></div>
          </div>
          <Tag color={canLogin ? 'success' : 'default'}>
            {canLogin ? 'Разрешён' : 'Запрещён'}
          </Tag>
        </div>
      </Card>

      <Card size="small" title={<Text strong>Текущие роли</Text>}>
        <Space wrap>
          {canLogin
            ? <Tag icon={<GoogleOutlined />} color="success">Google доступ</Tag>
            : <Tag icon={<GoogleOutlined />} color="default">Нет доступа</Tag>}
          {employee.is_super_admin && <Tag icon={<CrownOutlined />} color="gold">Супер-админ</Tag>}
          {employee.is_admin       && <Tag icon={<SettingOutlined />} color="purple">Админ</Tag>}
          {employee.is_security    && <Tag icon={<SafetyOutlined />} color="red">СБ</Tag>}
          {canLogin && !employee.is_admin && !employee.is_super_admin && !employee.is_security && (
            <Tag color="blue">Пользователь</Tag>
          )}
        </Space>
      </Card>
    </div>
  );
}